import * as _ from "underscore";
import * as ko from 'knockout';

import { findComponentBindingContext } from "Scripts/ts/Knockout/koUtilFunctions";

export namespace OverriddenByTemplateBindings {
    ko.virtualElements.allowedBindings.overriddenByTemplate = true;
    ko.bindingHandlers.overriddenByTemplate = {
        init: (element: any, valueAccessor: () => string, allBindings, viewModel, bindingContext: KnockoutBindingContext) => {

            var componentTemplateNodes = bindingContext.$componentTemplateNodes;
            var templateName = valueAccessor();

            var template = _.find(componentTemplateNodes,
                (node: HTMLElement) =>
                    node.tagName == "TEMPLATE" && node.dataset && node.dataset.name === templateName) as HTMLTemplateElement;

            if (template) {
                // find the binding context that is the actual component context
                // in most cases this will be the original binding context, but if we're in a with/foreach we need to traverse upwards.
                var componentContext = findComponentBindingContext(bindingContext);


                var childBindingContext = bindingContext.createChildContext({
                    markup: template.content.childNodes,
                    // we want to use the immediate parent context for binding 
                    // this means the markup is bound in the context it's defined in.
                    context: componentContext.$parent
                });

                var startNode = document.createComment(" ko template: { nodes: markup, data: context } ");
                var endNode = document.createComment(" /ko ");

                ko.virtualElements.setDomNodeChildren(element, { [0]: startNode, [1]: endNode, length: 2 });

                ko.applyBindingsToDescendants(childBindingContext, element);

                // Also tell KO *not* to bind the descendants itself, otherwise they will be bound twice
                return { controlsDescendantBindings: true };
            }
        }
    };
}